var _defs, _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDanhGiaNangLuc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "13 0 224 224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:none;}.cls-2{fill:#18b575;}.cls-3{fill:#3d55a5;}.cls-4{fill:#fdbc42;}.cls-5{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 31.07,
    y: 31.07,
    width: 187.87,
    height: 187.87
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M161.42,146.07a18.47,18.47,0,0,1-10.2,3.06h0a18.55,18.55,0,0,0-13.12,5.43h0a18.57,18.57,0,0,1-21.75,3.3l14.13,38.83a7.84,7.84,0,0,0,12.61,3.16l10-8.92,13.38.42a7.84,7.84,0,0,0,7.62-10.52Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M111.86,154.55h0a18.54,18.54,0,0,0-13.12-5.44h0a18.44,18.44,0,0,1-10.16-3.05L75.93,180.83a7.84,7.84,0,0,0,7.62,10.52l13.38-.42,10,8.92a7.84,7.84,0,0,0,12.61-3.16l14.14-38.85A18.57,18.57,0,0,1,111.86,154.55Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "SVGID",
    className: "cls-4",
    d: "M151.22,149.13h0a18.55,18.55,0,0,0-13.12,5.43h0a18.57,18.57,0,0,1-26.24,0h0a18.54,18.54,0,0,0-13.12-5.44h0A18.56,18.56,0,0,1,80.2,130.55h0a18.55,18.55,0,0,0-5.43-13.12h0a18.56,18.56,0,0,1,0-26.24h0a18.56,18.56,0,0,0,5.44-13.12h0A18.55,18.55,0,0,1,98.78,59.52h0A18.54,18.54,0,0,0,111.9,54.1l.89-.89a17.29,17.29,0,0,1,24.46,0l.89.9a18.53,18.53,0,0,0,13.12,5.43h0A18.56,18.56,0,0,1,169.8,78.1h0a18.55,18.55,0,0,0,5.43,13.12h0a18.54,18.54,0,0,1,0,26.23h0a18.56,18.56,0,0,0-5.44,13.12h0A18.55,18.55,0,0,1,151.22,149.13Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M122,126.47a6.75,6.75,0,0,1-4.61-1.81l-18-16.74a6.76,6.76,0,0,1,9.22-9.9l13.22,12.3,19.32-19.21a6.76,6.76,0,1,1,9.54,9.59L126.8,124.5A6.76,6.76,0,0,1,122,126.47Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanhGiaNangLuc);
export default __webpack_public_path__ + "static/media/danh_gia_nang_luc.9110ced326106ba78fc5acf79fd3cf09.svg";
export { ForwardRef as ReactComponent };